
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/asset/etf",
      function () {
        return require("private-next-pages/asset/etf.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/asset/etf"])
      });
    }
  